import { createSlice } from "@reduxjs/toolkit";

export const affiliateSlice = createSlice({
  name: "affiliateCode",
  initialState: {},

  reducers: {
    getAffiliateCodeSuccess: (state, action) => action.payload,
    getAffiliateCodeError: (state) => state,
  },
});

export const { getAffiliateCodeSuccess, getAffiliateCodeError } =
  affiliateSlice.actions;

export default affiliateSlice.reducer;
